﻿$(function ()
{
    $(document).on('click', '.rating-help', function (event)
    {
        event.preventDefault();
        var valueRating = $(this).data("value-rating");
        var spriteNum = $(this).data("value-spritenum");

        $.magnificPopup.open({
            preloader: false,
            fixedContentPos: true,
            type: 'inline',
            mainClass: 'slide-left',
            removalDelay: 200,
            items: {
                src: '<div class="modal-leasing-value">' +
                    '<button title="Close (Esc)" type="button" class="mfp-close">×</button>' +
                    '<div class="title">Value score explained</div>' +
                    '<div class="value-rating-gauge-wrap size3 legend" data-rating-slice="' + spriteNum + '">' +
                    '<div class="gauge"> </div>' +
                    '<div class="gauge-number mfp-valueRating">' + valueRating + '</div>' +
                    '<div class="gauge-legend"></div>' +
                    '</div>' +
                    '<p class="value-header">Looking for the best leasing deals?<br>We&apos;ve created the Leasing.com Value Score to help you find them.</p>' +
                    '<p>96.1% of people get the best deal on Leasing.com. We&apos;ve developed an advanced algorithm to give every one of the offers on our site a score out of ten, ' +
                    'which you can use to compare deals and rank them. So, if you&apos;re looking for a bargain, or want to know if you&apos;re getting value for money, just check the score. </p>' +
                    '</div>'
            }
        });
    });
});
